import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type FailedLoadTriggerPayload = {
    loadGroupId?: string;
    totalLoads?: number;
    failedLoads?: number;
    type?: string;
    isEnabled?: boolean;
    load?: any[];
    groupPath?: any[];
    loadGroupName?: string;
    loadGroupsItem?: any;
};

type LoadGroupsState = {
    failedLoadTrigger: FailedLoadTriggerPayload | null;
    isFailedLoadModalOpen: boolean;
    payload: any;
};

const initialState: LoadGroupsState = {
    failedLoadTrigger: null,
    isFailedLoadModalOpen: false,
    payload: {},
};

const loadGroupsSlice = createSlice({
    name: 'loadGroups',
    initialState,
    reducers: {
        setFailedLoadTrigger: (state, action: PayloadAction<FailedLoadTriggerPayload>) => {
            state.failedLoadTrigger = action.payload;
            state.isFailedLoadModalOpen = true;
        },
        setLoadGroupsPayload: (state, action) => {
            state.payload = action.payload;
        },
        clearLoadGroupsPayload: (state) => {
            state.payload = {};
        },
        clearFailedLoadTrigger: (state) => {
            state.failedLoadTrigger = null;
            state.isFailedLoadModalOpen = false;
        },
        closeFailedLoadModal: (state) => {
            state.isFailedLoadModalOpen = false;
        },
    },
});

export const {
    setFailedLoadTrigger,
    clearFailedLoadTrigger,
    closeFailedLoadModal,
    setLoadGroupsPayload,
    clearLoadGroupsPayload,
} = loadGroupsSlice.actions;
export default loadGroupsSlice;
